import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48012637"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed } from 'vue';
import store, { CollabStatus } from '@app/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'collabStatusBanner',
  setup(__props) {

const visibleStatus = computed<Exclude<CollabStatus, 'connected'> | null>(() => {
  // Only surface a banner when at least one editor has actual unsynced
  // local changes at risk; a dropped connection on an untouched field is
  // not a save failure for the user.
  const atRisk = Object.values(store.state.collabConnections)
    .filter((entry) => entry.hasUnsyncedChanges);
  if (atRisk.some((entry) => entry.status === 'authError')) {
    return 'authError';
  }
  if (atRisk.some((entry) => entry.status === 'reconnecting')) {
    return 'reconnecting';
  }
  return null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (visibleStatus.value !== null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
        'collab-status-banner alert mb-0 rounded-0 text-center py-2',
        visibleStatus.value === 'authError' ? 'alert-danger' : 'alert-warning',
      ]),
          role: "alert",
          "aria-live": "assertive"
        }, [
          (visibleStatus.value === 'authError')
            ? (_openBlock(), _createElementBlock("strong", _hoisted_1, " Your changes can't be saved. Please refresh the page to sign in again. "))
            : (_openBlock(), _createElementBlock("strong", _hoisted_2, " We're having trouble saving your changes. They'll be saved when the connection is restored — please don't close this tab. "))
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})